import React from 'react';

import './blog-post-skeleton.css';

export const BlogPostSkeleton = () => (
  <div className="blog-post-item-skeleton">
    <div className="blog-post-item-skeleton__category" />

    <div className="blog-post-item-skeleton__title" />

    <div className="blog-post-item-skeleton__date" />

    <div className="blog-post-item-skeleton__cover-image" />

    <div className="blog-post-item-skeleton__content">
      <div className="blog-post-item-skeleton__content__row" />
      <div className="blog-post-item-skeleton__content__row" />
      <div className="blog-post-item-skeleton__content__row" />
      <div className="blog-post-item-skeleton__content__row blog-post-item-skeleton__content__row--half" />
    </div>
  </div>
);
